import { render } from "./RIASecurityView.vue?vue&type=template&id=9118a90a&scoped=true&ts=true"
import script from "./RIASecurityView.vue?vue&type=script&lang=ts"
export * from "./RIASecurityView.vue?vue&type=script&lang=ts"

import "./RIASecurityView.vue?vue&type=style&index=0&id=9118a90a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9118a90a"]])

export default __exports__